import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import { Box, Button, LinearProgress, Paper, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { BADGE_SX, SURFACE_SX } from './crmDashboardStyles';

function CountChip({ children, tone = 'planned' }) {
  const toneSx =
    tone === 'overdue'
      ? {
          color: '#b71c1c',
          backgroundColor: 'rgba(198,40,40,0.10)',
          borderColor: 'rgba(198,40,40,0.20)',
        }
      : tone === 'today'
      ? {
          color: '#7a4b00',
          backgroundColor: 'rgba(255,193,7,0.16)',
          borderColor: 'rgba(255,193,7,0.32)',
        }
      : {
          color: 'primary.main',
          backgroundColor: 'rgba(0,121,107,0.08)',
          borderColor: 'rgba(0,121,107,0.16)',
        };

  return (
    <Box component="span" sx={{ ...BADGE_SX, ...toneSx, minHeight: 28, px: 1.1 }}>
      {children}
    </Box>
  );
}

const CrmDashboardHeaderBar = memo(function CrmDashboardHeaderBar({
  counts,
  isLoading = false,
  isMobile = false,
  isTenantWideView = false,
  onRefresh,
  refreshDisabled = false,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        ...SURFACE_SX,
        p: { xs: 1.5, md: 1.75 },
        position: { xs: 'sticky', md: 'static' },
        top: { xs: 8, md: 'auto' },
        zIndex: { xs: 12, md: 'auto' },
      }}
    >
      <Stack spacing={1.1}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={1.25}
          justifyContent="space-between"
          alignItems={{ xs: 'stretch', md: 'center' }}
        >
          <Box>
            <Typography variant={isMobile ? 'h6' : 'h5'} fontWeight={700}>
              Activity Planner
            </Typography>
            {!isMobile && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.35 }}>
                {isTenantWideView
                  ? 'Review tenant activity by due date, including work that still needs an owner.'
                  : 'Review your assigned CRM work by due date and keep the planned queue visible.'}
              </Typography>
            )}
          </Box>

          <Button
            type="button"
            variant="outlined"
            size="small"
            startIcon={<RefreshRoundedIcon fontSize="small" />}
            disabled={refreshDisabled}
            onClick={onRefresh}
            sx={{ alignSelf: { xs: 'flex-start', md: 'center' }, textTransform: 'none' }}
          >
            {isLoading ? 'Refreshing...' : 'Refresh'}
          </Button>
        </Stack>

        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          <CountChip tone="overdue">
            {isTenantWideView ? `Overdue activities ${counts.overdue}` : `Overdue ${counts.overdue}`}
          </CountChip>
          <CountChip tone="today">
            {isTenantWideView
              ? `Activities due today ${counts.dueToday}`
              : `Due today ${counts.dueToday}`}
          </CountChip>
          <CountChip>{`Planned activities ${counts.planned}`}</CountChip>
        </Stack>

        {isLoading && <LinearProgress sx={{ borderRadius: 999 }} />}
      </Stack>
    </Paper>
  );
});

export default CrmDashboardHeaderBar;
